{
  "noClasses": "Nicio clasă nu ți-a fost atribuită încă",
  "noUpcomingSessions": "Nicio ședință viitoare.",
  "statusCancelled": "Anulată",
  "sessionSummary": "{attending} participă · {notAttending} nu · {absent} absenți",
  "markAbsent": "Marchează absent",
  "undo": "Anulează",
  "attendanceUpdated": "Prezență actualizată"
}
